module.exports = __webpack_public_path__ + "img/terms-bg@dt.4a48543.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/terms-bg@dt.svg
// module id = 2FKm
// module chunks = 7